var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeRoadAb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 40 40",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#6D6D6D",
    fillOpacity: 0.7,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.323 25.273-1.105-2.997h-4.015l-1.105 2.997h-1.63l3.942-10.43h1.63l3.927 10.43zm-2.589-7.288a7 7 0 0 0-.16-.48 29 29 0 0 1-.364-1.236q-.116.45-.261.96a14 14 0 0 1-.233.756l-1.047 2.924h3.112zm8.673-3.098q1.98 0 2.997.582 1.032.582 1.032 2.007 0 .916-.494 1.528-.48.596-1.382.756v.073q.61.102 1.106.378.509.276.8.785.29.494.29 1.31 0 1.41-.989 2.196-.988.77-2.676.77h-3.724V14.888zm.262 4.335q1.222 0 1.673-.393.465-.393.465-1.164t-.552-1.105q-.553-.35-1.76-.35h-1.557v3.012zm-1.73 1.28v3.462h1.905q1.251 0 1.745-.495.51-.495.51-1.309 0-.742-.524-1.193-.51-.465-1.833-.465z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.096 32.38a9.4 9.4 0 0 1-1.47.267 14 14 0 0 1-1.47.08q-2.513 0-4.745-.894a13.1 13.1 0 0 1-3.969-2.47A12.9 12.9 0 0 1 8.61 25.65a12.7 12.7 0 0 1-1.336-4.619h1.63A9.8 9.8 0 0 0 10 24.849 11.7 11.7 0 0 0 12.392 28c.971.908 3.314 2.203 3.314 2.203l2.266-2.23zM16.905 7.62a9.4 9.4 0 0 1 1.472-.267q.777-.08 1.5-.08 2.49 0 4.738.894 2.25.895 3.976 2.47a13 13 0 0 1 2.825 3.712 12.3 12.3 0 0 1 1.311 4.619h-1.606a9.8 9.8 0 0 0-1.098-3.818 11.7 11.7 0 0 0-2.396-3.151c-.973-.908-3.32-2.203-3.32-2.203l-2.27 2.23z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeRoadAb);
export default __webpack_public_path__ + "static/media/ChangeRoadAB.ef8f5565f1ab3c06065828ded9ab2faf.svg";
export { ForwardRef as ReactComponent };